import React from "react";
import ChevronsRightIcon from "../../../../shared-components/icons/ChevronsRightIcon";
import { useSubscriptionCompetitionsPrizesPageContext } from "../context";

const CtaButton = () => {
  const { onViewPlansClick } = useSubscriptionCompetitionsPrizesPageContext();
  return (
    <button
      onClick={() => onViewPlansClick("sc_details_cta")}
      className="theme-btn theme-btn-primary theme-btn-lg lg:theme-btn-2xl uppercase w-full">
      Enter now
      <ChevronsRightIcon variant={3} className={"size-4 lg:size-5 shrink-0"} />
    </button>
  );
};

export default CtaButton;
